import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { TipoCausalCausalSolicitud } from '../../_models/tipo-causal-causal-solicitud';

@Component( {
  selector: 'app-tipo-causal-listado',
  templateUrl: 'tipo-causal-listado.component.html'
} )

export class TipoCausalListadoComponent implements OnInit {

  lisTiposCausales: ListaItem[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDialogo = false;
  lisCausales: TipoCausalCausalSolicitud[] = [];
  tipCausalSeleccionada: ListaItem;
  colCausales: any[] = [];


  constructor( private lisServicio: ListaService,
               private navServicio: NavService,
               private router: Router,
               private tipCausalServicio: TipoCausalCausalSolicitudService,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-causal' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'TIPOCAUSAL.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'TIPOCAUSAL.LBL_TIPOCAUSAL' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.colCausales = [
      { field: 'nombreListaCausalSolicitud', header: this.navServicio.buscarMensaje( 'TIPOCAUSAL.LBL_CAUSALASIGNADA' ), sort: true }
    ];

    this.busqueda = this.navServicio.getSearch( 'tipo-causal.component' );

    this.lisServicio.getMasterDetails( 'ListasTiposCausalesSolicitudes' ).subscribe( lista => {
      this.lisTiposCausales = lista;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }


  ver( tipCausal: ListaItem ) {
    this.carTabla = true;
    this.lisCausales = [];
    this.tipCausalSeleccionada = tipCausal;
    this.tipCausalServicio.listadoPorTipoCausal( tipCausal.idLista ).subscribe( lisTipoCausal => {
      this.lisCausales = lisTipoCausal.filter(x => x.indicadorHabilitado);
      this.mosDialogo = true;
      this.carTabla = false;
    } );
  }

  editar( tipCausal: ListaItem ) {
    this.router.navigate( [ 'apl/tipo-causal/actualizar/' + tipCausal.idLista ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-causal.component', this.busqueda );
  }

  cerrar() {
    this.mosDialogo = false;
  }
}
